import React, { useState, useEffect, useCallback } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { setQueryValue } from "@api/shared_screeners"
import debounce from "debounce"

const Search = ({ setQueryValue }) => {
  const [search, setSearch] = useState("")

  const debouncedSetQueryValue = useCallback(
    debounce((value) => {
      setQueryValue("search", value)
    }, 300),
    [setQueryValue]
  )

  useEffect(() => {
    debouncedSetQueryValue(search)
  }, [search, debouncedSetQueryValue])

  return (
    <input
      className='cs-input'
      placeholder='Search for reviewers...'
      autoComplete='off'
      type='search'
      style={{ height: "34px" }}
      onChange={e => setSearch(e.target.value)}
      value={search}/>
  )
}

Search.propTypes = {
  setQueryValue: PropTypes.func.isRequired
}

const mapDispatchToProps = dispatch => ({
  setQueryValue: bindActionCreators(setQueryValue, dispatch)
})

export default connect(null, mapDispatchToProps)(Search)